// TODO: @gergely - No good typing yet for sequenced motion
/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";

import Plus24 from "@ui/icons/24x24/plus-24.svg";
import ArrowUp from "@ui/icons/arrow_up.svg";
import clsx from "clsx";
import Image from "next/image";
import { MODELS, TIMING, TRANSITIONS } from "./types";
import { appUrls } from "@/constants";
import { useTranslations } from "next-intl";

export function IconImage({ className }: { className?: string }) {
  return (
    <svg viewBox='0 0 20 20' className={className} fill='none'>
      <rect x='2.5' y='4.167' width='15' height='11.667' rx='1.667' stroke='currentColor' strokeWidth='1.5' />
      <circle cx='6.667' cy='7.917' r='1.25' stroke='currentColor' strokeWidth='1.5' />
      <path
        d='M2.5 13.333 6.25 10l3.125 2.5L12.5 10l5 5'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export function IconVideo({ className }: { className?: string }) {
  return (
    <svg viewBox='0 0 20 20' fill='currentColor' className={className}>
      <path
        d='M3.33325 9.99992H6.66658M3.33325 9.99992V6.66658M3.33325 9.99992V13.3333M6.66658 9.99992H13.3333M6.66658 9.99992V13.3333M6.66658 9.99992V6.66658M3.33325 6.66658V4.99992C3.33325 4.07944 4.07944 3.33325 4.99992 3.33325H6.66658M3.33325 6.66658H6.66658M3.33325 13.3333V14.9999C3.33325 15.9204 4.07944 16.6666 4.99992 16.6666H6.66658M3.33325 13.3333H6.66658M13.3333 9.99992H16.6666M13.3333 9.99992V13.7036M13.3333 9.99992V6.66658M6.66658 13.3333V16.6666M6.66658 6.66658V3.33325M16.6666 9.99992V6.66658M16.6666 9.99992V13.7036M13.3333 13.7036V16.6666M13.3333 13.7036H16.6666M13.3333 6.66658V3.33325M13.3333 6.66658H16.6666M16.6666 6.66658V4.99992C16.6666 4.07944 15.9204 3.33325 14.9999 3.33325H13.3333M16.6666 13.7036V14.9999C16.6666 15.9204 15.9204 16.6666 14.9999 16.6666H13.3333M13.3333 16.6666H6.66658M13.3333 3.33325H6.66658'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='square'
      />
    </svg>
  );
}

export function IconAspectRatio({ className }: { className?: string }) {
  return (
    <svg viewBox='0 0 20 20' className={className} fill='none'>
      <path
        d='M2.5 5.83329C2.5 4.91282 3.24619 4.16663 4.16667 4.16663H15.8333C16.7538 4.16663 17.5 4.91282 17.5 5.83329V14.1666C17.5 15.0871 16.7538 15.8333 15.8333 15.8333H4.16667C3.24619 15.8333 2.5 15.0871 2.5 14.1666V5.83329Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export function IconQuality({ className }: { className?: string }) {
  return (
    <svg viewBox='0 0 20 20' className={className} fill='none'>
      <path
        d='M7.91716 6.66671L6.25049 8.33337L7.91716 10M11.179 16.3215L17.9406 9.55996C18.6099 8.89062 18.5881 7.79885 17.8925 7.15678L14.2293 3.77537C13.9214 3.49118 13.5178 3.33337 13.0988 3.33337H6.90213C6.48315 3.33337 6.07954 3.49118 5.77167 3.77537L2.10847 7.15678C1.4129 7.79885 1.39107 8.89062 2.06042 9.55996L8.822 16.3215C9.47283 16.9724 10.5282 16.9724 11.179 16.3215Z'
        stroke='currentColor'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
}

export function IconLayers({ className }: { className?: string }) {
  return (
    <svg viewBox='0 0 20 20' className={className} fill='none'>
      <path
        d='M6.58346 10.0001L2.99386 11.7511C2.36989 12.0554 2.36989 12.9447 2.99386 13.249L9.63475 16.4885C9.86533 16.601 10.1349 16.601 10.3655 16.4885L17.0064 13.249C17.6303 12.9447 17.6303 12.0554 17.0064 11.7511L13.4168 10.0001M6.58346 10.0001L2.99386 8.24903C2.36989 7.94464 2.36989 7.05545 2.99386 6.75108L9.63475 3.5116C9.86533 3.39913 10.1349 3.39913 10.3655 3.5116L17.0064 6.75108C17.6303 7.05545 17.6303 7.94464 17.0064 8.24903L13.4168 10.0001M6.58346 10.0001L9.63475 11.4885C9.86533 11.601 10.1349 11.601 10.3655 11.4885L13.4168 10.0001'
        stroke='currentColor'
        stroke-width='1.5'
        stroke-linecap='square'
        stroke-linejoin='round'
      />
    </svg>
  );
}

export function ControlItem({
  icon,
  label,
  sequencedMotion,
  className,
  ...props
}: {
  icon: React.ReactNode;
  label: React.ReactNode;
  sequencedMotion: any;
  className?: string;
  [key: string]: any;
}) {
  const m = sequencedMotion;
  return (
    <m.div className={clsx("tw-flex tw-items-center tw-gap-1 text-light", className)} {...props}>
      {icon}
      {typeof label === "string" ? <span className='f-paragraph-03'>{label}</span> : label}
    </m.div>
  );
}

export function ModelSelector({
  sequencedMotion,
  currentModel,
  targetModel,
  models: modelsList,
  ...props
}: {
  sequencedMotion: any;
  currentModel: string;
  targetModel: string;
  models?: readonly string[];
  [key: string]: any;
}) {
  const m = sequencedMotion;
  const items = modelsList ?? MODELS;

  return (
    <m.div
      className='tw-absolute tw-left-0 tw-top-full tw-mt-2 tw-rounded-2xl tw-overflow-hidden tw-shadow-lg tw-z-20 bg-default'
      {...props}
    >
      {items.map((model, index) => {
        const isCurrentModel = model === currentModel;
        const isTargetModel = model === targetModel;

        return (
          <m.div
            key={model}
            className='tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2.5 tw-cursor-pointer tw-min-w-[180px] tw-relative'
          >
            {/* Background highlight for current/selected model */}
            <m.div
              className='tw-absolute tw-inset-0 bg-dark-new'
              initial={{ opacity: isCurrentModel ? 0.5 : 0 }}
              animate={{
                OPEN_MODEL_SELECTOR: { opacity: isCurrentModel ? 0.5 : 0 },
                SELECT_MODEL: { opacity: isTargetModel ? 0.5 : 0 },
              }}
              transition={{
                OPEN_MODEL_SELECTOR: TRANSITIONS.fast,
                SELECT_MODEL: { ...TRANSITIONS.medium, delay: TIMING.DELAY.MEDIUM + index * 0.1 },
              }}
            />

            <span className='tw-relative tw-z-10 f-paragraph-03'>{model}</span>

            {/* Checkmark for selected model */}
            <m.div
              className='tw-ml-auto tw-relative tw-z-10'
              initial={{ opacity: 0 }}
              animate={{
                OPEN_MODEL_SELECTOR: { opacity: isCurrentModel ? 1 : 0 },
                SELECT_MODEL: { opacity: isTargetModel ? 1 : 0 },
              }}
              transition={{
                OPEN_MODEL_SELECTOR: TRANSITIONS.fast,
                SELECT_MODEL: { ...TRANSITIONS.medium, delay: TIMING.DELAY.LONG },
              }}
            >
              <svg width='16' height='16' viewBox='0 0 16 16' fill='currentColor'>
                <path
                  d='M13.5 4.5L6 12L2.5 8.5'
                  stroke='currentColor'
                  strokeWidth='2'
                  fill='none'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
            </m.div>
          </m.div>
        );
      })}
    </m.div>
  );
}

export function PromptContentArea({
  sequencedMotion,
  className,
  ...props
}: {
  sequencedMotion: any;
  className?: string;
  [key: string]: any;
}) {
  const Component = sequencedMotion.div;
  return (
    <Component
      className={clsx(
        "tw-mb-2 tw-rounded-[14px] tw-overflow-hidden tw-aspect-[3/2] tw-h-16 tw-ml-1 tw-mt-1 tw-relative bg-dark-new",
        className,
      )}
      {...props}
    />
  );
}

export function PromptTextInput({
  sequencedMotion,
  className,
  ...props
}: {
  sequencedMotion: any;
  className?: string;
  [key: string]: any;
}) {
  const Component = sequencedMotion.div;
  return <Component className={clsx("tw-mx-2 tw-max-w-full tw-relative text-light", className)} {...props} />;
}

export function PromptControlBar({
  sequencedMotion,
  controls,
  button,
  className,
  ...props
}: {
  sequencedMotion: any;
  controls?: React.ReactNode;
  button?: React.ReactNode;
  className?: string;
  [key: string]: any;
}) {
  const Component = sequencedMotion.div;
  return (
    <Component className={clsx("tw-flex tw-items-center tw-justify-between tw-gap-3", className)} {...props}>
      <div className='tw-flex tw-items-center tw-gap-3 tw-ml-2'>{controls}</div>
      {button}
    </Component>
  );
}

export function ContentPlaceholder({
  sequencedMotion,
  icon = <Plus24 className='tw-w-6 tw-h-6 text-light' />,
  className,
  ...props
}: {
  sequencedMotion: any;
  icon?: React.ReactNode;
  className?: string;
  [key: string]: any;
}) {
  const Component = sequencedMotion.div;
  return (
    <Component
      className={clsx("tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center bg-dark-new", className)}
      {...props}
    >
      {icon}
    </Component>
  );
}

export function ContentImage({
  sequencedMotion,
  src,
  alt = "Uploaded image",
  className,
  ...props
}: {
  sequencedMotion: any;
  src: string;
  alt?: string;
  className?: string;
  [key: string]: any;
}) {
  const Component = sequencedMotion.div;
  return (
    <Component className={clsx("tw-absolute tw-inset-0", className)} {...props}>
      <Image src={src} alt={alt} fill className='tw-object-cover' />
    </Component>
  );
}

export function ContentVideo({
  sequencedMotion,
  src,
  className,
  ...props
}: {
  sequencedMotion: any;
  src: string;
  className?: string;
  [key: string]: any;
}) {
  const Component = sequencedMotion.div;
  return (
    <Component className={clsx("tw-absolute tw-inset-0", className)} {...props}>
      <video src={src} className='tw-w-full tw-h-full tw-object-cover' autoPlay loop muted playsInline />
    </Component>
  );
}

export function ContentAudio({
  sequencedMotion,
  className,
  ...props
}: {
  sequencedMotion: any;
  className?: string;
  [key: string]: any;
}) {
  const Component = sequencedMotion.div;
  return (
    <Component
      className={clsx(
        "tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center tw-gap-px tw-px-1 bg-dark-new",
        className,
      )}
      {...props}
    >
      {/* Simple audio waveform visualization with bars */}
      {[
        0.1, 0.15, 0.4, 0.3, 0.5, 0.4, 0.4, 0.1, 0.15, 0.1, 0.2, 0.3, 0.5, 0.4, 0.4, 0.1, 0.1, 0.4, 0.3, 0.5, 0.4, 0.4,
        0.2, 0.5, 0.4, 0.2, 0.5, 0.2, 0.1,
      ].map((height, i) => (
        <div key={i} className='tw-w-[2px] tw-bg-gray-200 tw-rounded-sm' style={{ height: `${height * 100}%` }} />
      ))}
    </Component>
  );
}

export function ContentProcessingOverlay({
  sequencedMotion,
  spinner,
  className,
  ...props
}: {
  sequencedMotion: any;
  spinner?: React.ReactNode;
  className?: string;
  [key: string]: any;
}) {
  const Component = sequencedMotion.div;
  const SpinnerComponent = sequencedMotion.div;

  return (
    <Component
      className={clsx(
        "tw-absolute tw-inset-0 tw-backdrop-blur-sm tw-bg-white/20 tw-flex tw-items-center tw-justify-center",
        className,
      )}
      {...props}
    >
      {spinner || (
        <SpinnerComponent className='tw-w-4 tw-h-4 tw-border-2 tw-border-white tw-border-t-transparent tw-rounded-full' />
      )}
    </Component>
  );
}

export function TypingText({
  sequencedMotion,
  text,
  className,
  children,
  ...props
}: {
  sequencedMotion: any;
  text: string;
  className?: string;
  children?: React.ReactNode;
  [key: string]: any;
}) {
  const Component = sequencedMotion.span;
  return (
    <Component className={clsx("f-paragraph-03 text-light", className)} {...props}>
      {children || text}
    </Component>
  );
}

export function TextPlaceholder({
  sequencedMotion,
  text,
  className,
  ...props
}: {
  sequencedMotion: any;
  text: string;
  className?: string;
  [key: string]: any;
}) {
  const Component = sequencedMotion.span;
  return (
    <Component className={clsx("f-paragraph-03 text-light", className)} {...props}>
      {text}
    </Component>
  );
}

export function SendButton({
  sequencedMotion,
  icon = <ArrowUp className='tw-w-5 tw-h-5 tw-opacity-60' />,
  className,
  ...props
}: {
  sequencedMotion: any;
  icon?: React.ReactNode;
  className?: string;
  [key: string]: any;
}) {
  const Component = sequencedMotion.a;
  const t = useTranslations("ClientKeys.VideoImageGenerationHero");
  return (
    <Component
      className={clsx(
        "tw-size-11 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-cursor-pointer tw-shrink-0 bg-dark-new",
        className,
      )}
      aria-label={t("link_alt")}
      href={appUrls.imageVideo}
      target='_blank'
      {...props}
    >
      {icon}
    </Component>
  );
}
